const REVISION = 20220308035153;
const LINKS = [
	'https://stackoverflow.com/questions/61640429/how-to-replace-the-contents-of-a-target-in-svelte-instead-of-appending-to-childr',
	'https://svelte.dev/docs#compile-time-svelte-compile',
];


import App from './App.svelte';

const app = new App({
	target: document.getElementById('app'),
	props: {},
	hydrate: true,
});

export default app;
